<template>
	<v-container fluid class="ma-0 pa-0">
		<Header @currentGroup="currentGroupFunc" @currentStores="currentStoresFunc" />
    	<v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<v-col class="ma-0 pa-5" cols="12" align="center">
				<v-col class="ma-0 pa-0 mt-15" cols="12" id="group_box"
					v-if="storeSearch == false">
					<v-col class="ma-0 pa-2" cols="12" id="group_box_title">
						{{tsg('createCameraList')}}
					</v-col>
					<v-col class="ma-0 pt-6 pb-6 pl-15 pr-15" cols="12" align="left">
						<v-col class="ma-0 pa-0 pb-2" cols="12">{{tsg('addCameraListSelectCamera')}}</v-col>
						<v-col class="ma-0 pa-0 pb-3" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<!-- vuetify Autocompletes API search 사용할것 -->
								<v-autocomplete
									v-model="cameraSearchInputValue"
									:items="searchResult"
									:loading="searchLoading"
									:search-input.sync="search" append-icon=""
									color="white" dark hide-no-data hide-selected outlined dense hide-details
									item-text="cameraName"
									:placeholder="tsg('cameraInputPlaceholder')"
									return-object style="width:67%;"
								></v-autocomplete>
								<!-- <input id="group_input" :placeholder="tsg('cameraInputPlaceholder')"
									style="width:67%;"> -->
								<v-btn width="12%" height="auto" class="ma-0 pa-2 ml-2" 
									id="blue_btn" elevation="0" @click="addCameraToList(cameraSearchInputValue)">
									{{tsg('add')}}
								</v-btn>
								<v-btn width="18%" height="auto" class="ma-0 pa-2 ml-2" 
									id="blue_btn" elevation="0" @click="storeSearch = true">
									{{tsg('searchCamera')}}
								</v-btn>
							</v-row>
						</v-col>
						<v-col class="ma-0 pa-0" cols="12" id="store_list">
							<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12"
								v-for="(item, index) in cameraList" :key="index">
								<v-col class="ma-0 pa-2 pt-1 pb-1" cols="12" id="store_item">
									<v-row class="ma-0 pa-0" align="center" justify="space-between">
										{{item.name}}
										<v-btn width="auto" height="auto" class="ma-0 pa-0 mr-5" 
											id="back_clean_btn" elevation="0" @click="removeCamera(item)">
											<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
												src="@/assets/images/close.png"></v-img>
										</v-btn>
									</v-row>
								</v-col>
							</v-col>
						</v-col>
						<v-col class="ma-0 pa-0 mt-5" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
									id="grey_btn" elevation="0" @click="goViewScreen">
										{{t('back')}}
								</v-btn>
								<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
									id="blue_btn" elevation="0" @click="goCCTVCheckList">
										{{t('create')}}
								</v-btn>
							</v-row>
						</v-col>
					</v-col>
				</v-col>

				<v-col class="ma-0 pa-0 mt-15" cols="12" id="group_box"
					v-else>
					<v-col class="ma-0 pa-2" cols="12" id="group_box_title">
						{{tsg('searchCamera2')}}
					</v-col>
					<!-- ###### 점포 목록 트리뷰 -->
					<v-row class="ma-0 pa-0" justify="center" v-if="filterOn == false && tagOn == false">
						<v-col class="ma-0 pa-0 pt-5 pb-5" cols="11">
							<v-row class="ma-0 pa-0 dialog_text" align="center">
								{{t('theConditions')}}:
								<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
									id="back_clean_btn" elevation="0" @click="filterOn = true">
									<v-row class="ma-0 pa-0" align="center" style="color:white;">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/plus_white.png"></v-img>
										{{t('filtering')}}
									</v-row>
								</v-btn>
								<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
									id="back_clean_btn" elevation="0" @click="tagOn = true">
									<v-row class="ma-0 pa-0" align="center" style="color:white;">
										<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
											src="@/assets/images/plus_white.png"></v-img>
											{{t('tag')}}
									</v-row>
								</v-btn>
							</v-row>
              <template v-if="areaLoading == false">
							  <v-row class="ma-0 pa-0 pb-2" justify="start">
							  	<v-col class="ma-0 pa-0" cols="12" id="noneBorderBox">
							  		<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12"
											v-if="storeList.length > 0">
							  			<v-treeview selected-color="blue"
							  				selectable dark dense @update:open="treeviewOpenFunc"
                        v-model="selection" item-disabled="locked"
							  				:items="storeList" return-object>
							  				<template v-slot:label="{item}">
							  					<v-col v-if="item.lastNode == true && item.streamAble" class="ma-0 pa-0" cols="auto">
							  						<v-img :src="item.thumbnail"
							  							id="treeview_image">
							  						</v-img>
							  						<v-col class="ma-0 pa-0" cols="auto" id="treeview_screen_bar">
							  							{{item.name}}
							  						</v-col>
							  					</v-col>
                          <v-col v-else-if="item.lastNode == true && !item.streamAble" class="ma-0 pa-0" cols="auto">
                            <v-img :src="require(`@/assets/images/grey_box.png`)"
                              id="treeview_image">
                            </v-img>
							  						<v-col class="ma-0 pa-0" cols="auto" id="treeview_screen_bar">
							  							{{item.name}}
							  						</v-col>
                          </v-col>
							  					<span v-else>
							  						{{item.name}}
							  					</span>
							  				</template>
							  			</v-treeview>
							  		</v-col>
										<v-col class="ma-0 pa-12" cols="12"
											v-else>{{t('noData')}}</v-col>
							  	</v-col>
							  </v-row>
              </template>
              <template v-else>
								<v-row class="ma-0 pa-0 pb-2" justify="start">
									<v-col class="ma-0 pa-0" cols="12" id="noneBorderBox">
										<v-skeleton-loader
											:boilerplate="false" elevation="0" dark 
											type="list-item-three-line, list-item-two-line, list-item-three-line"
										></v-skeleton-loader>
									</v-col>
								</v-row>
              </template>
							<v-row class="ma-0 pa-0 pt-2 pb-2" align="center" justify="center">
								<v-btn class="ma-0 pa-0" width="8rem" height="2rem" id="grey_btn" 
									@click="storeSearch = false">{{t('back')}}</v-btn>
								<v-btn class="ma-0 pa-0 ml-2" width="8rem" height="2rem" id="blue_btn" 
									@click="addCamerasToList">{{t('add')}}</v-btn>
							</v-row>
						</v-col>
					</v-row>
					
					<!-- ############# 필터링 부분 -->
					<v-row class="ma-0 pa-0" justify="center" v-if="filterOn">
						<v-col class="ma-0 pa-0 pt-5 pb-5" cols="11">
							<v-row class="ma-0 pa-0 mb-10 dialog_text" align="center" justify="space-between">
								<v-row class="ma-0 pa-0 dialog_text" align="center">
									{{t('theConditions')}}:
									<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
										id="back_clean_btn" elevation="0" @click="filterOpenBtn">
										<v-row class="ma-0 pa-0" align="center" style="color:white;">
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
												:class="{'rotate_icon': filterOn }"
												src="@/assets/images/plus_white.png"></v-img>
												{{t('filtering')}}
										</v-row>
									</v-btn>
									<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
										id="back_clean_btn" elevation="0" @click="tagOpenBtn">
										<v-row class="ma-0 pa-0" align="center" style="color:white;">
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
												:class="{'rotate_icon': tagOn }"
												src="@/assets/images/plus_white.png"></v-img>
												{{t('tag')}}
										</v-row>
									</v-btn>
								</v-row>
								<v-col class="ma-0 pa-0" cols="auto">
									<v-btn id="blue_btn" @click="filterOn = false">
										{{t('sure')}}
									</v-btn>
									<v-btn id="grey_btn" class="ml-2" @click="resetFiltering">
										{{t('reset')}}
									</v-btn>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-0 pb-2" justify="center">
								<v-col class="ma-0 pa-0" cols="12" id="filterBox">
									<v-col class="ma-0 pa-0" cols="12">
										<v-row class="ma-0 pa-0">
											<v-col class="ma-0 pa-2 pr-4" cols="2" align="right"
												style="border-right: 3px solid #4A4A4A;">
												{{t('cctvCamera')}}
											</v-col>
											<v-col class="ma-0 pa-0" cols="10">
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" v-model="motionCheck"/>
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('motionDetect')}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-row class="ma-0 pa-0" align="center" justify="space-between">
															<v-col class="ma-0 pa-0" cols="5.5">
																<CustomDatePicker :viewTextField="true" :initDate="true"
																	@resultDate="motionDetectBeginDateFunc" />
															</v-col>
															<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
															<v-col class="ma-0 pa-0" cols="5.5">
																<CustomDatePicker :viewTextField="true"
																	@resultDate="motionDetectEndingDateFunc" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" v-model="soundCheck"/>
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('soundDetect')}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-row class="ma-0 pa-0" align="center" justify="space-between">
															<v-col class="ma-0 pa-0" cols="5.5">
																<CustomDatePicker :viewTextField="true" :initDate="true"
																	@resultDate="soundDetectBeginDateFunc" />
															</v-col>
															<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
															<v-col class="ma-0 pa-0" cols="5.5">
																<CustomDatePicker :viewTextField="true"
																	@resultDate="soundDetectEndingDateFunc" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>
												<!-- <v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" />
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{'人物検出'}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-btn width="7rem" height="auto" class="ma-0 pa-2" 
															id="grey_btn" elevation="0">
															{{'人物検出'}}
														</v-btn>
													</v-col>
												</v-row> -->
											</v-col>
										</v-row>
										<!-- <v-row class="ma-0 pa-0 mt-5">
											<v-col class="ma-0 pa-2 pr-4" cols="2"  align="right"
												style="border-right: 3px solid #4A4A4A;">{{t('analyze')}}</v-col>
											<v-col class="ma-0 pa-0" cols="10">
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0 pl-6" cols="4">{{t('selectDuration')}}</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-row class="ma-0 pa-0" align="center" justify="space-between">
															<v-col class="ma-0 pa-0" cols="5.5">
																<CustomDatePicker :viewTextField="true" :time="false"
																	@resultDate="beginDateFunc" />
															</v-col>
															<v-col class="ma-0 pa-0 pl-1 pr-1" cols="auto" align="center">~</v-col>
															<v-col class="ma-0 pa-0" cols="5.5">
																<CustomDatePicker :viewTextField="true" :time="false"
																	@resultDate="endingDateFunc" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0 pl-6" cols="4">{{''}}</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-radio-group v-model="selectedAnylizeRadio"
															class="ma-0 pa-0" dense hide-details>
															<template v-for="item in anylizeRadioGroup">
																<v-radio :value="item.value" :key="item.value" dark
																	color="#1976d2">
																	<template v-slot:label>
																		<v-col class="ma-0 pa-0 pt-2 pb-2" cols="auto"
																			style="color:white;font-size:0.9rem;">
																			{{item.label}}
																		</v-col>
																	</template>
																</v-radio>
															</template>
														</v-radio-group>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" />
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('visitorCount')}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-row class="ma-0 pa-0" align="center">
															<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
																<v-select background-color="#272727" dark
																	v-model="selectedVisitantStartOption"
				      										:items="visitantStartOptionList" dense hide-details outlined 
																	item-text="label" item-value="value"
																></v-select>
															</v-col>
															<v-col class="ma-0 pa-0 pl-3 pr-3" cols="auto">~</v-col>
															<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
																<v-select background-color="#272727" dark
																	v-model="selectedVisitantEndOption"
				      										:items="visitantEndOptionList" dense hide-details outlined 
																	item-text="label" item-value="value"
																></v-select>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" />
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('genderRatio')}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-row class="ma-0 pa-0" align="center">
															<v-col class="ma-0 pa-0" cols="2">{{t('man') + ' : ' + manPercent/10 }}</v-col>
															<v-col class="ma-0 pa-0 pl-1 pr-1" cols="7" align-self="center">
																<v-slider class="slider_slot" step="10" v-model="manPercent"
																	dense hide-details dark></v-slider>
															</v-col>
															<v-col class="ma-0 pa-0" cols="2">{{t('weman') + ' : ' + womanPercent}}</v-col>
														</v-row>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-2 pt-0 pl-4" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" />
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('repeaterRatio')}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
															<v-select background-color="#272727" dark
																v-model="selectedReVisitantOption"
				      									:items="reVisitantOptionList" dense hide-details outlined 
																item-text="label" item-value="value"
															></v-select>
														</v-col>
													</v-col>
												</v-row>
												<v-row class="ma-0 pa-2 pt-0 pl-4 pb-3" align="center">
													<v-col class="ma-0 pa-0" cols="4">
														<v-row class="ma-0 pa-0" align="center">
															<input id="check_box" type="checkbox" />
															<v-col class="ma-0 pa-0 ml-3" cols="auto">{{t('sales')}}</v-col>
														</v-row>
													</v-col>
													<v-col class="ma-0 pa-0" cols="8">
														<v-row class="ma-0 pa-0" align="center">
															<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
																<v-select background-color="#272727" dark
																	v-model="selectedSalesStartOption"
				      										:items="salesStartOptionList" dense hide-details outlined 
																	item-text="label" item-value="value"
																></v-select>
															</v-col>
															<v-col class="ma-0 pa-0 pl-3 pr-3" cols="auto">~</v-col>
															<v-col class="ma-0 pa-0" cols="auto" style="width:8rem;">
																<v-select background-color="#272727" dark
																	v-model="selectedSalesEndOption"
				      										:items="salesEndOptionList" dense hide-details outlined 
																	item-text="label" item-value="value"
																></v-select>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-col>
										</v-row> -->
									</v-col>
								</v-col>
							</v-row>
						</v-col>
					</v-row>

					<!-- ########### 태그 부분 -->
					<v-row class="ma-0 pa-0" justify="center" v-if="tagOn">
						<v-col class="ma-0 pa-0 pt-5 pb-5" cols="11" id="filterBox">
							<v-row class="ma-0 pa-0 mb-5 dialog_text" align="center" justify="space-between">
								<v-row class="ma-0 pa-0 dialog_text" align="center">
									{{t('theConditions')}}:
									<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
										id="back_clean_btn" elevation="0" @click="filterOpenBtn">
										<v-row class="ma-0 pa-0" align="center" style="color:white;">
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
												:class="{'rotate_icon': filterOn }"
												src="@/assets/images/plus_white.png"></v-img>
												{{t('filtering')}}
										</v-row>
									</v-btn>
									<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
										id="back_clean_btn" elevation="0" @click="tagOpenBtn">
										<v-row class="ma-0 pa-0" align="center" style="color:white;">
											<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
												:class="{'rotate_icon': tagOn }"
												src="@/assets/images/plus_white.png"></v-img>
												{{t('tag')}}
										</v-row>
									</v-btn>
								</v-row>
								<v-col class="ma-0 pa-0" cols="auto">
									<v-btn id="blue_btn" @click="tagOn = false">
										{{t('sure')}}
									</v-btn>
									<v-btn id="grey_btn" class="ml-2" @click="resetTag">
										{{t('reset')}}
									</v-btn>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-0 pb-2" justify="start">
                <v-col class="ma-0 pa-0" cols="auto" v-for="item in tagList" :key="item.label">
                  <template v-if="item.selected">
								  	<v-btn width="auto" height="auto" class="ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4" 
								  		id="blue_btn" elevation="0" style="border-radius:25px;font-size:0.8rem;"
								  		@click="tagClick(item)">
								  		{{item.label}}	
								  	</v-btn>
                  </template>
								  <template v-else>
								  	<v-btn width="auto" height="auto" class="ma-0 pa-2 pt-1 pb-1 pl-3 pr-3 mr-3 mb-4" 
								  		id="grey_btn" elevation="0" style="border-radius:25px;font-size:0.8rem;"
								  		@click="tagClick(item)">
								  		{{item.label}}	
								  	</v-btn>
								  </template>
                </v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from '../Header.vue';
import CustomDatePicker from '@/components/DatePicker.vue';
import { VISTANT_START_OPTION, VISITANT_END_OPTION, REVISITANT_OPTION,
	SALES_START_OPTION, SALES_END_OPTION } from '@/constants';
import { GroupTestCameraList, ImageTreeviewTestStoreData } from '../../whitetest/sampleData';
export default {
	components: {
		Header, CustomDatePicker
	},
	mixins: [mixin.common],
	data: () => ({
    currentGroupId: '',
		storeSearch: false,
		filterOn: false,
		tagOn: false,
    motionCheck: false,
    soundCheck: false,
    cameraList: [],
		storeList: [],
    storeCameraList: [],
		motionDetectBeginDate: '',
		motionDetectEndingDate: '',
		soundDetectBeginDate: '',
		soundDetectEndingDate: '',
		beginDate: '',
		endingDate: '',
		manPercent: 0,
		womanPercent: 0,
		visitantStartOptionList: VISTANT_START_OPTION,
		selectedVisitantStartOption: '10人',
		visitantEndOptionList: VISITANT_END_OPTION,
		selectedVisitantEndOption: '100人',
		reVisitantOptionList: REVISITANT_OPTION,
		selectedReVisitantOption: '50',
    salesStartOptionList: SALES_START_OPTION,
		selectedSalesStartOption: '100,000',
		salesEndOptionList: SALES_END_OPTION,
		selectedSalesEndOption: '500,000',
		tagList: [],
    selectedTagList: [],
    tagNames: '',
		cameraSearchInputValue: null,
		searchLoading: false,
    model: null,
    search: null,
		searchResult: [],
		brandList: [],
    selection: [],
    areaLoading: false,
		selectedAnylizeRadio: 0,
    deviceStatusList: ['5', '10', '12', '17', '19', '20'],
    listCount: 1, //번호 붙이기를 위한 리스트 갯수
    currentGroup: [],
		storeAllCamera: [],
	}),
	computed: {
		anylizeRadioGroup() {
			return [
				{ label: this.$i18n.t('lang.common.requirementsOnAllDates'), value: 0 },
				{ label: this.$i18n.t('lang.common.conditionsEvenForOneDay'), value: 1 },
				{ label: this.$i18n.t('lang.common.conditionsInTotalValue'), value: 2 },
			];
		}
	},
	watch: {
		manPercent: function(item) {
			this.womanPercent = 10 - item / 10;
		},
		search(val) {
			this.requestCameraSearch(val);
		},
		cameraSearchInputValue: function(item) {
			// v-autocomplate에서 선택한 값
			console.log(item);
		},
    tagOn: function(item) {
      console.log(item);
      this.tagNames = this.makeTagStr();
      this.getAreaStores();
    },
    filterOn: function(item) {
      if(item == false) {
        if(this.motionCheck == false) {
          this.motionDetectBeginDate = '';
          this.motionDetectEndingDate = '';
        }
        if(this.soundCheck == false) {
          this.soundDetectBeginDate = '';
          this.soundDetectEndingDate = '';
        }
      	this.getAreaStores();
      }
    }
	},
	created() {
		this.currentGroupId = this.$route.query.groupId;
	},
	mounted() {
		this.getAllTagList();
    this.getAreaStores();
    this.getGroupCameraList();
		// this.getBrandData();
	},
	methods: {
		tsg(t) {
      return this.$t("lang.group." + t);
    },
		filterOpenBtn() {
			this.filterOn = !this.filterOn;
			this.tagOn = false;
		},
		tagOpenBtn() {
			this.tagOn = !this.tagOn;
			this.filterOn = false;
		},
		async getGroupCameraList() { //생성 시 번호를 붙이기 위해 전체 리스트 길이 구하기
			let params = {};
			await this.networkController.getStoreGroupCameraList(params, this.currentGroupId).then(async (res) => {
        let maxIndex = 0;
        res.data.forEach((item) => {
          if(item.groupName.includes('名称未設定')) {
            let tempIndex = item.groupName.split('名称未設定')[1] * 1;
            if(tempIndex >= maxIndex) {
              maxIndex = tempIndex;
            }
          }
        });
        this.listCount = maxIndex + 1;
			}).catch(error => { });
		},
		async goCCTVCheckList() { //카메라 리스트 생성 후 바로 카메라 리스트 페이지로 이동
      //로딩 추가
			this.$vloading.show();
      let params = {
        cameras: [],
        groupName: "名称未設定" + this.listCount,
        storeGroupId: this.currentGroupId
      };
      if(this.cameraList.length != 0){
        for(var i=0; i<this.cameraList.length; i++) {
          params.cameras.push({
            cameraName: this.cameraList[i].cameraName,
            contractCd: this.cameraList[i].contractCd,
            portNo: this.cameraList[i].portNo,
            unisCustomerCd: this.cameraList[i].unisCustomerCd,
						thingType: this.cameraList[i].thingType,
						size: 1 // 뷰크기 1(소)로 초기값 설정
          });
        }
        await this.networkController.addCameraCheckListGroup(params)
        .then(async (res) => {
					this.showToastMessage(this.tmb('requestSuccess'));
          this.$vloading.hide();
			    this.pushRoute('/store-group/camera-list/view', { groupId: this.currentGroupId });
        }).catch(error => {
          console.log(error);
          this.$vloading.hide();
        });
      } else {
				this.showToastMessage(this.tmb('requestFail'));
        this.$vloading.hide();
      }
		},
		async requestCameraSearch(value) {
			this.searchLoading = true;
			let params = {};
			await this.networkController.getCameraFromCameraName(params, value)
			.then(async (res) => {
				console.log('%cCamera Search\n', "color:#008DD0;", res.data);
				this.searchResult = [];
        res.data.forEach((item) => { //점포에 포함된 카메라만 result에 포함
					let idx = this.storeAllCamera.findIndex((el, index, array) => {
						return el.cameraName === item.cameraName && el.cameraName.length === item.cameraName.length
					});
          if(idx != -1) this.searchResult.push(item);
        });

				this.searchLoading = false;
			}).catch(error => {
				this.searchLoading = false;
			});
		},
		async getBrandData() {
			let params = {};
			await this.networkController.getBrandList(params).then(async (res) => {
				console.log('%cBrand Data\n', "color:#008DD0;", res.data);
        this.brandList = res.data;
			}).catch(error => { });
			await this.getAreaStores();
		},
		makeBrandCd() {
			if(this.brandList.length == 0) return '';
			let brandCd = '';
			this.brandList.forEach((item, index) => {
				if(index == 0) brandCd = item.brandCd;
				else brandCd = brandCd + ',' + item.brandCd;
			});
			return brandCd;
		},
		async getAreaStores() {
			this.areaLoading = true;
			let brandCd = await this.makeBrandCd();
			let params = {};
			await this.networkController.getStoresModalSearch(params, brandCd,'','','','')
			.then(async (res) => {
				console.log('%cArea Data\n', "color:#008DD0;", res.data);
				// Area Data 중복제거
				const arraySet = await res.data.filter((area, idx, arr) => {
					return arr.findIndex((item) => item.unisCustomerCd === area.unisCustomerCd) === idx
				});
        this.storeList = [];
        arraySet.forEach((item) => {
				  let children = [];
          let cameraListparams = {};
			    this.networkController.getStoreCameraList(cameraListparams, item.unisCustomerCd, this.motionDetectBeginDate, this.motionDetectEndingDate,
          	this.soundDetectBeginDate, this.soundDetectEndingDate, this.tagNames)
			    .then(async (res) => {
            if(res.data.length != 0) {
              let childrenList = [];
              res.data.forEach((item) => {
                if(item.isOnline == false) {
                  let data = item;
						      data.streamAble = false;
                  childrenList.push({"id": item.id, "name": item.cameraName, "lastNode": true, ...data});
                } else {
						      let data = item;
						      data.streamAble = true;
                  childrenList.push({"id": item.id, "name": item.cameraName, "lastNode": true, ...data});
                }
              });
              //카메라가 없는 경우 diable
              if(this.currentGroup.stores.findIndex(r => r.unisCustomerCd === item.unisCustomerCd) != -1)
                children.push({"id": item.unisCustomerCd, "name": item.customerName, "children": childrenList, "locked": childrenList.length != 0 ? false : true, ...item});

              let duplicateCheck = this.storeList.some((element) => {
					    	return element.id === item.areaCd
					    });
              if(duplicateCheck == false && children.length != 0) { // duplicateCheck가 true일때는 areaCd 중복
					  	  this.storeList.push({"id": item.areaCd, "name": item.areaName, "children": children});
					    } else {
                let storeIndex = this.storeList.findIndex((r) => r.id == item.areaCd);
                let childArray = this.storeList[storeIndex].children;
                this.storeList[storeIndex].children = childArray.concat(children);
              }
            }
			    }).catch(error => { });
        });
				this.areaLoading = false;
			}).catch(error => {
				this.areaLoading = false;
			});
    },
		async getAllTagList() {
			let params = {};
			await this.networkController.getAllTagList(params)
			.then(async (res) => {
				console.log('%cAll Tag List\n', "color:#008DD0;", res.data);
				this.tagList = res.data.cameraTagNames.map(item => {
          return { label: item, selected: false }
        });
			}).catch(error => { });
		},
    async tagClick(tag) {
      let getIndex = await this.tagList.findIndex((element, index, arr) => element.label == tag.label);
      if(this.tagList[getIndex].selected == false) {
        this.selectedTagList.push(tag);
        this.tagList[getIndex].selected = !this.tagList[getIndex].selected;
      } else {
        this.tagList[getIndex].selected = !this.tagList[getIndex].selected;
				if(this.selectedTagList.length != 0) {
					let selectedGetIndex = await this.selectedTagList.findIndex((element, index, arr) => element.label === tag.label);
					this.selectedTagList.splice(selectedGetIndex, 1);
				}
      }
      console.log(this.selectedTagList);
    },
    makeTagStr() {
      let tagStr = '';
			this.selectedTagList.forEach((item, index) => {
				if(index == 0) {
					tagStr = item.label;
				} else {
					tagStr = tagStr + ',' + item.label;
				}
			});
			return tagStr;
    },
    resetFiltering() {
      this.motionCheck = false;
      this.soundCheck = false;
      this.resetValue = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString();
      this.filterOn = false;
    },
    resetTag() {
      this.tagList.forEach((item) => {
        item.selected = false;
      })
      this.selectedTagList = [];
      this.tagNames = '';
      this.tagOn = false;
    },
		treeviewOpenFunc(item) {
			// console.log(item);
			// if(this.storeList.length != 0) {
			// 	let store = this.storeList.find(r => r.areaCd === item);
			// 	console.log(store);
			// }
		},
    addCameraToList(item) { //카메라 1개 추가
      if(item != null) {
        var index = this.cameraList.findIndex(dataIndex => dataIndex.id == item.id);
        if(index == -1)
          this.cameraList.push({name: item.cameraName, ...item});
        this.cameraSearchInputValue = null;
      }
    },
    addCamerasToList() { //체크박스를 이용해서 여러개 카메라 추가
      for(var i=0; i<this.selection.length; i++) {
      var index = this.cameraList.findIndex(dataIndex => dataIndex.id == this.selection[i].id);
        if(index == -1) {
          this.cameraList.push(this.selection[i]);
        }
      }
      this.storeSearch = false;
    },
    removeCamera(item) {
      var index = this.cameraList.indexOf(item);
      this.cameraList.splice(index, 1);
    },
		motionDetectBeginDateFunc(date) {
			this.motionDetectBeginDate = date;
		},
		motionDetectEndingDateFunc(date) {
			this.motionDetectEndingDate = date;
		},
		soundDetectBeginDateFunc(date) {
			this.soundDetectBeginDate = date;
		},
		soundDetectEndingDateFunc(date) {
			this.soundDetectEndingDate = date;
		},
		beginDateFunc(date) {
			this.beginDate = date;
		},
		endingDateFunc(date) {
			this.endingDate = date;
		},
		goViewScreen() {
			this.pushRoute('/store-group/camera-list/view', { groupId: this.currentGroupId });
		},
    currentGroupFunc(item) {
      this.currentGroup = item;
    },
    currentStoresFunc(item) {
			this.storeAllCamera = [];
      item.forEach((store) => {
				store.storeCameras.forEach((camera) => {
					this.storeAllCamera.push(camera);
				})
			})
    }
	}
}

</script>

<style lang="scss" scoped>
#group_box {
	background-color: #171921;
	border: 1px solid #6A6A6A;
	color: white;
	border-radius: 5px;
	max-width: 700px;
	font-size: 0.9rem;
}
#group_box_title {
	border-bottom: 1px solid #6A6A6A;
}
#store_list {
	border: 1px solid #4A4A4A;
	overflow: auto;
	min-height: 350px;
	max-height: 350px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#filterBox {
	min-height: 350px;
  overflow: auto;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#noneBorderBox {
	min-height: 350px;
	max-height: 350px;
  overflow: auto;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#group_input {
	background-color: #272727;
	border: 1px solid #4A4A4A;
	border-radius: 4px;
	color: white;
	padding: 5px;
}
#store_item {
	border-bottom: 1px solid #4A4A4A;
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
	.v-treeview--dense .v-treeview-node__root {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node .v-treeview-node--leaf {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__checkbox { // 트리뷰 체크박스 CSS
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}
  .v-treeview-node__checkbox.v-icon--disabled {
    background-color: grey;
  }
	.v-input__slot {
		padding-right: 2px !important;
		min-height: 2rem !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}

	.v-autocomplete {
		background-color: #272727;
		input {
			padding-top: 2px;
			padding-bottom: 2px;
		}
	}
  	// v-skeleton-loader css 설정
  .theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
  	background: #171921 !important;
  }
  .theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
  	background: #171921 !important;
  }
	// Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#picker_bottom_menu {
	background-color: #272727;
  border: 1px solid #4A4A4A;
  color: white;
  justify-content: start;
}
.rotate_icon{
  transform: rotate(45deg);
}
#treeview_image {
  position: absolute;
  top: 0.5em;
  left: 5rem;
  width: 7rem;
  height: 4rem;
}
#treeview_screen_bar {
  position: absolute;
  left: 5rem;
  bottom: 2.3rem;
  background-color: rgba(0, 0, 0, 0.7);
  width: 7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #A8A8A8;
  font-size: 0.8em;
}
::v-deep .v-treeview-node__children > div > div {
  border-bottom: none;
  display: flex;
  flex-wrap: wrap;
  .v-treeview-node__root {
    border-bottom: none;
    padding-top: 0.5rem;
    padding-bottom: 3em;
  }
  .v-treeview-node.v-treeview-node--leaf {
    width: 8.5em;
    border: none;
    height: 6em;
  }
  .v-treeview-node__checkbox {
    z-index: 3;
  }
}
.tag_style {
  height: 1.8em;
  background-color: #4E5367 !important;
	color: white;
}
.tag_selected {
  background-color: #008DD0 !important;
  color: white !important;
}
</style>